/**
 * Returns true if the given notification is a chat notification.
 *
 * @param {object} notification The notification object to check.
 * @returns {boolean} Returns true if the notification is a chat notification, false otherwise.
 */
export function isChatNotification(notification) {
    return !! notification ?. content ?. data ?. chatId;
}
